import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { userFarmDetail } from "../../../config/farmDetails";
import DropdownOptions from "../../../constants/DropdownOptions";
import AllMainFarmSelectedDialog from "../../Common/AllMainFarmSelectedDialog";
import { isSuperAdmin } from "../../Common/CheckAuthorization";
import CreateTable from "../../CreateTable";
import Loader from "../../Loader";
import { userDeleteAction, userDisableAction, userEditAction, userEnableAction, userListAction } from "./../../../modules/users/action";


class UserListTable extends Component {
  state = {
    fetchingComplete: false,
    headerRows: {
      updatedAt: "Date",
      updatedBy: "Updated By",
      externalUserId: "Employee Id",
      name: "Name",
      username: "Email/Username",
      displayedRoleName: "Type",
      enabled: "Status"
    },
    order: "desc",
    orderBy: "id"
  };

  componentWillMount() {
    const { userListAction, SubFarmId = userFarmDetail().id } = this.props;
    if(!isSuperAdmin() || this.props.MainFarmId !== DropdownOptions.ALL_MAIN_FARM.id){
      userListAction(SubFarmId);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.usersList &&
      this.props.usersList !== nextProps.usersList &&
      this.state.fetchingComplete === false
    ) {
      this.setState({ fetchingComplete: true });
    } else if (
      nextProps.ErrorMessage &&
      this.props.ErrorMessage !== nextProps.ErrorMessage
    ) {
      this.setState({ fetchingComplete: true });
    }
    if (nextProps.SubFarmId && nextProps.SubFarmId !== this.props.SubFarmId && nextProps.SubFarmId!== DropdownOptions.ALL_MAIN_FARM.id) {
      this.props.userListAction(nextProps.SubFarmId);
    }
  }

  deleteRow = id => {
    //this.props.userDeleteAction(id);
  };

  editRow = id => {
    const { usersList } = this.props;
    const requiredData = usersList.find(user => user.id === id);
    this.props.userEditAction(requiredData);
  };

  toggle = (id, isChecked) => {
    isChecked
      ? this.props.userDisableAction(id)
      : this.props.userEnableAction(id);
  };

  handleRequestSort = (event, property) => {
    const isDesc =
      this.state.orderBy === property && this.state.order === "desc";
    this.setState({
      order: isDesc ? "asc" : "desc",
      orderBy: property
    });
  };

  render() {
    const { headerRows, order, orderBy, fetchingComplete } = this.state;
    const { usersList, location } = this.props;
    return (
      <div>
      {isSuperAdmin() && this.props.MainFarmId === DropdownOptions.ALL_MAIN_FARM.id ? 
      (<AllMainFarmSelectedDialog/>) : 
      (
      <div>
        {fetchingComplete ? (
          <CreateTable
            order={order}
            orderBy={orderBy}
            headerRows={headerRows}
            rowData={usersList}
            onRequestSort={this.handleRequestSort}
            isMenuRequired={true}
            //delete={this.deleteRow}
            edit={this.editRow}
            toggle={this.toggle}
            location={location}
          />
        ) : (
          <Loader />
        )}
      </div>
      )}

      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    usersList: state.settingsUserReducer.usersList,
    ErrorMessage: state.globalserverMessage.ErrorMessage,
    SubFarmId: state.FarmManagementReducer.SubFarmId,
    MainFarmId: state.FarmManagementReducer.MainFarmId
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      userListAction,
      userEditAction,
      userDeleteAction,
      userDisableAction,
      userEnableAction
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserListTable);



// WEBPACK FOOTER //
// ./src/components/private/Users/UserListTable.js